//
// Copyright 2024 DXOS.org
//

import React, { useCallback } from 'react';

import { Input, type SwitchProps } from '@dxos/react-ui';

import { type FormFieldRendererProps } from '#types';

import { FormRow } from '../../FormRow';

export const BooleanField = ({ type, readonly, onValueChange, ...props }: FormFieldRendererProps<boolean>) => {
  const handleChange = useCallback<NonNullable<SwitchProps['onCheckedChange']>>(
    (value) => onValueChange?.(type, value),
    [type, onValueChange],
  );

  return (
    <FormRow<boolean> readonly={readonly} {...props}>
      {({ value }) => (
        <Input.Block>
          <Input.Switch disabled={!!readonly} checked={value} onCheckedChange={handleChange} />
        </Input.Block>
      )}
    </FormRow>
  );
};
